import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import ContactWidgets from "./components/feature/ContactWidgets";
import InterstitialAd from "./components/feature/InterstitialAd";
import { siteData } from "@/store/siteData";
import { initLogoFromCache } from "@/hooks/useLogoUrl";
import { applyPalette, getSavedPalette, isFeatureEnabled } from "@/pages/dev-panel/page";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    siteData.load().then((cache) => {
      // Renk paletini tüm sayfalarda uygula — site geneli
      applyPalette(getSavedPalette());
      initLogoFromCache(cache as Record<string, unknown>);
      setIsLoaded(true);
    });
  }, []);

  if (!isLoaded) {
    return null; // Veya basit bir yükleniyor animasyonu konulabilir
  }

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <ContactWidgets />
        {isFeatureEnabled("ad_manager") && <InterstitialAd />}
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
